import "./Title.css";


function Kumar(){
    return(
        <div className="card">
            <label value="#home"className="title-bar">Home</label>
            <label value="#about" className="title-bar">About</label>
            <label value="#searc" className="title-bar">Search</label>
            <label value="#contect" className="title-bar">Contect</label>
            <label value="#login" className="title-bar">Login</label>
        </div>
    )
}

export default Kumar;